import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  fetchProgress, setProgress,
  fetchWordProgress, setWordProgress,
} from "@/lib/api";

/**
 * Shared "New / Learning / Known" status buttons. `kind` decides whether it
 * targets the kanji or compound (word) progress collection.
 */
export default function ProgressButtons({ kind = "kanji", id, testIdPrefix = "progress" }) {
  const qc = useQueryClient();
  const isWord = kind === "word";
  const queryKey = isWord ? ["word-progress"] : ["progress"];
  const q = useQuery({
    queryKey,
    queryFn: isWord ? fetchWordProgress : fetchProgress,
  });
  const items = q.data?.items || {};
  const currentStatus = items[id]?.status || "new";

  const m = useMutation({
    mutationFn: (s) => (isWord ? setWordProgress(id, s) : setProgress(id, s)),
    onSuccess: () => qc.invalidateQueries({ queryKey }),
  });

  const opt = (val, label, color) => {
    const active = currentStatus === val;
    return (
      <button
        key={val}
        data-testid={`${testIdPrefix}-${val}`}
        onClick={() => m.mutate(val)}
        className={`flex-1 text-[10px] uppercase tracking-[0.25em] font-sans py-2 transition-colors border ${
          active ? "text-washi border-transparent" : "text-sumi border-borderDefault hover:border-sumi"
        }`}
        style={active ? { background: color } : undefined}
      >
        {label}
      </button>
    );
  };
  return (
    <div className="flex gap-1.5">
      {opt("new", "New", "#7A746D")}
      {opt("learning", "Learning", "#D29C4C")}
      {opt("known", "Known", "#6E7A5A")}
      {opt("hidden", "Hide", "#B45A4C")}
    </div>
  );
}
